// WelcomeStep Component
// Screen 1: Welcome message and role selection

import React from 'react';
import { FaUser, FaBuilding, FaChalkboardTeacher, FaUserFriends } from 'react-icons/fa';
import styles from './WelcomeStep.module.css';

const WelcomeStep = ({ formData, updateFormData, onNext }) => {
  const roles = [
    {
      id: 'player',
      label: "I'm a Player",
      description: 'Track my athletic journey and connect with clubs',
      icon: <FaUser />
    },
    {
      id: 'parent',
      label: "I'm a Parent of a Player",
      description: 'Manage my child\'s athletic journey and memberships',
      icon: <FaUserFriends />
    },
    {
      id: 'club_owner',
      label: "I'm a Club Owner",
      description: 'Manage my clubs, programs, and members',
      icon: <FaBuilding />
    },
    {
      id: 'coach',
      label: "I'm a Coach",
      description: 'Train players and manage my teams',
      icon: <FaChalkboardTeacher />
    }
  ];

  const handleRoleSelect = (role) => {
    updateFormData({ userRole: role });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.iconCircle}>
          <FaUser />
        </div>
        <h1 className={styles.title}>Welcome to SportLoop!</h1>
        <p className={styles.subtitle}>
          Let's get you set up in just a few simple steps
        </p>
      </div>

      <div className={styles.content}>
        <h2 className={styles.question}>What brings you here?</h2>
        
        <div className={styles.roles}>
          {roles.map((role) => (
            <button
              key={role.id}
              className={`${styles.roleCard} ${
                formData.userRole === role.id ? styles.selected : ''
              }`}
              onClick={() => handleRoleSelect(role.id)}
            >
              <div className={styles.roleIcon}>{role.icon}</div>
              <div className={styles.roleContent}>
                <h3 className={styles.roleLabel}>{role.label}</h3>
                <p className={styles.roleDescription}>{role.description}</p>
              </div>
              <div className={styles.checkmark}>✓</div>
            </button>
          ))}
        </div>

        <button
          className={styles.nextButton}
          onClick={onNext}
          disabled={!formData.userRole}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default WelcomeStep;















